import { render, staticRenderFns } from "./visi-misi.vue?vue&type=template&id=62038044&"
import script from "./visi-misi.vue?vue&type=script&lang=js&"
export * from "./visi-misi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports